<template>
  <div>
    <div class="header_box" v-if="is_headers == 0">
      <el-row class="header">
        <el-col :xs="4" :sm="3" :md="2" :lg="2" :xl="2" class="header-nav">
          <div class="header-logo">
            <img
              :src="
                is_headers == 0
                  ? require('../assets/logo.png')
                  : require('../assets/logo_sel.jpg')
              "
              alt=""
            />
          </div>
        </el-col>
        <el-col :xs="4" :sm="20" :md="20" :lg="20" :xl="20" class="navcenter">
          <navMenu :isheaders="0" @changjqqd="changjqqd"></navMenu>
        </el-col>
        <el-col :xs="8" :sm="2" :md="2" :lg="2" :xl="2">
          <div :class="is_headers == 0 ? 'header-right' : 'header-slide-right'">
            <div class="languagewrap" @click="changeLang">
              <img
                class="right-icon"
                :src="
                  is_headers == 0
                    ? require('../assets/icon01.png')
                    : require('../assets/icon02.jpg')
                "
                alt=""
              />
              <span class="showLang">{{
                value == "中文" ? "ENG" : "中文"
              }}</span>
              <el-select
                v-model="value"
                placeholder="Language"
                @change="changeLang"
                :popper-class="is_headers == 0 ? 'dropdown' : 'dropdown_sel'"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="header_box_slide" v-if="is_headers == 1">
      <el-row class="header_slide">
        <el-col :xs="4" :sm="3" :md="2" :lg="2" :xl="2" class="header-nav">
          <div class="header-logo">
            <img
              :src="
                is_headers == 0
                  ? require('../assets/logo.png')
                  : require('../assets/logo_sel.jpg')
              "
              alt=""
            />
          </div>
        </el-col>
        <el-col :xs="4" :sm="20" :md="20" :lg="20" :xl="20" class="navcenter">
          <navMenu @changjqqd="changjqqd" :isheaders="1"></navMenu>
        </el-col>
        <el-col :xs="8" :sm="2" :md="2" :lg="2" :xl="2">
          <div :class="is_headers == 0 ? 'header-right' : 'header-slide-right'">
            <div class="languagewrap" @click="changeLang">
              <img
                class="right-icon"
                :src="
                  is_headers == 0
                    ? require('../assets/icon01.png')
                    : require('../assets/icon02.jpg')
                "
                alt=""
              />
              <span class="showLang">{{
                value == "中文" ? "ENG" : "中文"
              }}</span>
              <el-select
                v-model="value"
                placeholder="Language"
                @change="changeLang"
                :popper-class="is_headers == 0 ? 'dropdown' : 'dropdown_sel'"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="mobile-header-box">
      <el-row class="mobile-header">
        <el-col :xs="3" :sm="2">
          <div class="header-menu">
            <img
              v-if="isShowMenu"
              @click="showMenu"
              src="../assets/menu_icon.png"
              alt=""
            />
            <i v-else @click="closeMenu" class="el-icon-close"></i>
          </div>
        </el-col>
        <el-col :xs="16" :sm="16">BCEIA</el-col>
        <el-col :xs="5" :sm="3">
          <div class="mobile-header-right">
            <div class="language">
              <p :class="[langcur == 0 ? 'act' : '']" @click="changeMLang(0)">
                中文
              </p>
              <p :class="[langcur == 1 ? 'act' : '']" @click="changeMLang(1)">
                ENG
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <moblienavMenu v-if="!isShowMenu"></moblienavMenu>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="dialogVisible"
    >
      <img class="dialog_img" src="../assets/jqqd.jpg" />
      <div class="dialog_txt">
        {{ showtype == 0 ? "Stay Tuned" : "敬请期待" }}
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import navMenu from "../components/navMenu.vue";
import moblienavMenu from "../components/moblienavMenu.vue";
// import { getUser } from "@/api/api";
export default {
  components: {
    navMenu,
    moblienavMenu,
  },
  data() {
    return {
      dialogVisible: false,
      isLogin: true,
      langcur: 0,
      memberid: 0,
      options: [
        {
          value: "中文",
          label: "中文",
        },
        {
          value: "ENG",
          label: "ENG",
        },
      ],
      value: "",
      newLang: "中文",
      isShowMenu: true,
      userInfo: {
        nickname: "",
      },
      is_headers: 0,
      showtype: "",
    };
  },
  mounted() {
    this.memberid = localStorage.getItem("memberid");
    this.uuid = localStorage.getItem("uuid");
    this.loggedIn();
    if (
      localStorage.getItem("languageSet") == "cn" ||
      localStorage.getItem("languageSet") == null
    ) {
      this.value = "中文";
      this.newLang = "English";
      localStorage.setItem("languageSet", "cn");
    } else {
      this.value = "English";
      this.newLang = "中文";
      localStorage.setItem("languageSet", "en");
    }
    this.langSet = localStorage.getItem("languageSet") || "cn";
    if (this.langSet == "cn") {
      this.langcur = 0;
    } else {
      this.langcur = 1;
    }
    // this.getData();
    // 添加滚动事件监听器
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {},
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changebtn() {
      this.showtype = 0;
      this.dialogVisible = true;
    },
    changjqqd() {
      this.showtype = 1;
      this.dialogVisible = true;
    },
    handleScroll() {
      // 这里编写你需要执行的操作

      if (window.scrollY > 0) {
        this.is_headers = 1;
        // console.log(window.scrollY); // 输出当前滚动位置
      } else {
        this.is_headers = 0;
      }
    },
    login() {
      this.$router.push({
        name: "login",
      });
    },
    changeMLang(index) {
      if (index == 0) {
        this.langcur = index;
        this.$i18n.locale = "cn";
        location.reload();
      } else {
        // this.$i18n.locale = "en";
        this.this.showtype = 0;
        this.dialogVisible = true;
      }
      localStorage.setItem("languageSet", this.$i18n.locale);
      // location.reload();
    },
    showMenu() {
      this.isShowMenu = false;
    },
    closeMenu() {
      this.isShowMenu = true;
    },
    getData() {
      let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid: this.$uuid,
      });
      getUser(data)
        .then((res) => {
          console.log(res);
          if (res.data.errno == 0) {
            this.userInfo = res.data.rst;
            let improve = localStorage.getItem("improve");
            if (
              !this.userInfo.nickname ||
              !this.userInfo.country ||
              !this.userInfo.nickname ||
              !this.userInfo.nickname ||
              this.userInfo.nickname == "请填写姓名" ||
              this.userInfo.nickname == "请填写手机号" ||
              this.userInfo.nickname == "请填写公司名称" ||
              this.userInfo.country == "请填写国家"
            ) {
              console.log(improve, "aaa");
              localStorage.setItem("improve", true);
            } else {
              console.log(improve, "bbb");
              localStorage.setItem("improve", false);
              console.log(improve, "ccc");
              if (improve == null) {
                console.log("zzz");
                this.$router.push({ path: "/pair" });
              } else if (improve && improve !== "false") {
                console.log("xxx");
                this.$router.push({ path: "/pair" });
              }
            }
          } else {
            if (localStorage.getItem("Flag")) {
              localStorage.removeItem("Flag");
              location.reload();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeLang(e) {
      if (e == "ENG") {
        this.value = "中文";
        this.newLang = "English";
        localStorage.setItem("languageSet", "cn");
        // this.showtype = 0;
        // this.dialogVisible = true;
      } else {
        this.value = "ENG";
        localStorage.setItem("languageSet", "cn");
        this.newLang = "English";
      }
      this.$i18n.locale == "cn"
        ? (this.$i18n.locale = "en")
        : (this.$i18n.locale = "cn");
      localStorage.setItem("languageSet", this.$i18n.locale);
      location.reload();
      //console.log(localStorage.getItem('languageSet'));
    },
    loggedIn() {
      this.memberid = localStorage.getItem("memberid");
      //console.log(this.memberid)
      if (this.memberid == 0 || this.memberid == null) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
  },
};
</script>

<style lang="scss" >
.dialog {
  width: 350px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 151px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.mobile-header-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.header_box_slide {
  width: 100%;
  background: #f9f9f9;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  opacity: 0.9;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.header_slide {
  width: 1280px;
  height: 98px;
  margin: 0 auto;
  padding: 0 70px 0 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.header_box {
  width: 100%;
  // height: 98px;
  background: rgba($color: #000000, $alpha: 0.8);
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.header {
  width: 1280px;
  height: 98px;
  margin: 0 auto;
  padding: 0 70px 0 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.header-logo {
  width: 100%;
}
.header-logo img {
  width: 100%;
}
.header-right {
  width: 100%;
  font-size: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  .right-icon {
    width: 20px;
    height: 21px;
  }
  .lang {
    background: #cac28a;
    border-radius: 30px;
    width: 46%;
    display: flex;
    height: 38px;
    line-height: 30px;
    padding: 5px 10px;
    box-sizing: border-box;
    p {
      width: 50%;
      border-radius: 30px;
      .cur {
        background: #fff;
        color: #cac28a;
      }
    }
  }
}
.header-slide-right {
  width: 100%;
  font-size: 20px;
  color: #2c2c2c;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  .right-icon {
    width: 20px;
    height: 21px;
  }
  .lang {
    background: #cac28a;
    border-radius: 30px;
    width: 46%;
    display: flex;
    height: 38px;
    line-height: 30px;
    padding: 5px 10px;
    box-sizing: border-box;
    p {
      width: 50%;
      border-radius: 30px;
      .cur {
        background: #fff;
        color: #cac28a;
      }
    }
  }
}
.header-nav .el-row,
.container .el-col {
  height: 100%;
}
.el-col {
  border-radius: 0 !important;
}
.navcenter.el-col {
  min-height: 0;
  height: 100%;
}
.languagewrap {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
}
.languagewrap .el-select .el-input__inner {
  height: 38px;
  border: 0 none;
  background-color: #9b8b1c;
  color: #ffffff;
  padding: 0 10px;
  border-radius: 7px;
  margin-top: 0;
  visibility: hidden;
}
.languagewrap .el-select {
  position: absolute;
}
.languagewrap .el-select .el-input .el-select__caret {
  color: #fff;
}
.languagewrap .el-input__suffix {
  display: none;
}

.dropdown {
  background-color: rgba($color: #000000, $alpha: 0.8);
  border: 1px solid rgba($color: #000000, $alpha: 0.8);
  color: #333;
  font-size: 14px;
  padding: 8px 12px;
}

.dropdown {
  border-color: rgba($color: #000000, $alpha: 0.8);

  background-color: rgba($color: #000000, $alpha: 0.8);
  box-sizing: border-box;
  z-index: 99999;

  .el-select-dropdown__item {
    color: rgba($color: #ffffff, $alpha: 0.8);
  }
  .el-popper .popper__arrow {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  }
  .el-popper .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #fff;
    background-color: rgba($color: #000000, $alpha: 0.8);
  }
  .el-select-dropdown__item.selected {
    color: #fff;
  }
  .popper__arrow {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8) !important;
  }
  .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8) !important;
  }
}

.dropdown_sel {
  background-color: #f4f4f4;
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12);
  border: 1px solid #f4f4f4;
  color: #2c2c2e;
  font-size: 14px;
  padding: 8px 12px;
}

.dropdown_sel {
  background-color: #f4f4f4;
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
  z-index: 99999;

  .el-select-dropdown__item {
    color: #2c2c2e;
  }
  .el-popper .popper__arrow {
    border-bottom-color: #f4f4f4;
  }
  .el-popper .popper__arrow::after {
    border-bottom-color: #f4f4f4;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #2c2c2e;
    background-color: #f4f4f4;
  }
  .el-select-dropdown__item.selected {
    color: #2c2c2e;
  }
  .popper__arrow {
    border-bottom-color: #f4f4f4 !important;
  }
  .popper__arrow::after {
    border-bottom-color: #f4f4f4 !important;
  }
}

.showLang {
  // position: absolute;
  // top: 9px;
  // left: 10px;
  font-weight: 600;
  margin-left: 8px;
}

.mobile-header {
  display: none;
}
@media only screen and (max-width: 1280px) {
  .header {
    width: 100%;
    padding: 0 2%;
  }
  .header_slide {
    width: 100%;
    padding: 0 2%;
  }
}
@media only screen and (max-width: 1100px) {
  .header {
    padding: 0 1%;
  }
  .header_slide {
    padding: 0 1%;
  }
  .showLang {
    top: 12px;
    font-size: 17px;
    font-weight: normal;
  }
}

@media only screen and (max-width: 767px) {
  .header {
    display: none;
  }
  .header_box_slide {
    display: none;
  }
  .mobile-header {
    color: #fff;
    display: block;
    height: 0.88rem;
    text-align: center;
    line-height: 0.88rem;
    background: rgba($color: #000000, $alpha: 0.8);
    .header-menu {
      img {
        width: 0.36rem;
        height: 0.3rem;
      }
      i {
        font-size: 24px;
        position: relative;
        top: 2px;
      }
    }
    .mobile-header-right {
      display: flex;
      height: 0.88rem;
      align-items: center;
      padding-right: 0.2rem;
      justify-content: space-between;
      .language {
        width: 1.6rem;
        height: 0.48rem;
        display: flex;
        line-height: 0.4rem;
        background: #666;
        border-radius: 24px;
        padding: 0.05rem;
        box-sizing: border-box;
        z-index: 99;
        p {
          flex: 1;
          font-size: 12px;
          height: 100%;
          text-align: center;
        }
        .act {
          color: #000;
          background: #fff;
          border-radius: 14px;
        }
      }
    }
  }
}
</style>
